document.addEventListener('DOMContentLoaded', function () {

    // Subscribe form footer
    var subscribeBtn = document.getElementById('subscribe_submit');
    if (subscribeBtn) {
        subscribeBtn.addEventListener('click', function () {
            var form = document.getElementById('formSubscribe');
            if (form) form.submit();
        });
    }

    // Footer menu mobile toggle
    var smallDevice = window.matchMedia('(max-width: 769px)');

    function handleDeviceChange(e) {
        var openers = document.querySelectorAll('#footer h2, footer h2');
        var menus = document.querySelectorAll('.footer-menu div');

        if (e.matches) {
            openers.forEach(function (opener) {
                opener.classList.add('toggle');
            });
            menus.forEach(function (menu) {
                menu.classList.add('closed');
            });

            openers.forEach(function (btn) {
                // Avoid duplicate listeners by using a data attribute
                if (!btn.dataset.toggleBound) {
                    btn.dataset.toggleBound = 'true';
                    btn.addEventListener('click', function () {
                        this.classList.toggle('open');
                        var next = this.nextElementSibling;
                        if (next) next.classList.toggle('closed');
                    });
                }
            });
        } else {
            openers.forEach(function (opener) {
                opener.classList.remove('toggle');
                opener.classList.remove('open');
            });
            menus.forEach(function (menu) {
                menu.classList.remove('closed');
            });
        }
    }

    smallDevice.addEventListener('change', handleDeviceChange);
    handleDeviceChange(smallDevice);

});
